import ApiService from "@/core/services/ApiService";

class RepmanService {

    public static getData(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/repman', data)
    }

    public static update (id, target, data) {
        ApiService.setHeader()
        return ApiService.put(`api/repman/${id}/${target}`,data)
    }

    public static getOptions(resource, slug){
        ApiService.setHeader()
        return ApiService.get(resource, slug)
    }

    public static postOptions(resource: string, params: any){
        ApiService.setHeader()
        return ApiService.post(`api/repman/${resource}`, params)
    }

}

export default RepmanService;